/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Invite_SuccessInputs */

const es_admin_users_invite_success = /** @type {(inputs: Admin_Users_Invite_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitación enviada correctamente. Cuando el usuario se registre con este email, será agregado automáticamente a tu empresa.`)
};

const en_admin_users_invite_success = /** @type {(inputs: Admin_Users_Invite_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitation sent successfully. When the user registers with this email, they will be automatically added to your company.`)
};

/**
* | output |
* | --- |
* | "Invitation sent successfully. When the user registers with this email, they will be automatically added to your company." |
*
* @param {Admin_Users_Invite_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_users_invite_success = /** @type {((inputs?: Admin_Users_Invite_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Invite_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_users_invite_success(inputs)
	return en_admin_users_invite_success(inputs)
});
export { admin_users_invite_success as "admin.users.invite.success" }